module.exports = __webpack_public_path__ + "static/media/2A.fa13685d.png";